import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ko from './locales/ko.json';

const resources = {
  en: { translation: en },
  ko: { translation: ko },
};

// 브라우저 언어 감지 함수
const getInitialLanguage = () => {
  // 1. localStorage에 저장된 언어가 있으면 사용 (사용자가 명시적으로 변경한 경우)
  const saved = localStorage.getItem('i18nextLng');
  if (saved) {
    return saved;
  }

  // 2. localStorage가 없으면 브라우저 언어 감지
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('ko')) {
    return 'ko';
  } else if (browserLang.startsWith('en')) {
    return 'en';
  }

  // 3. 그 외의 경우 기본값 'en'
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    saveMissing: false,
  });

// 언어 변경 시 localStorage에 저장
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  console.log('언어 변경됨:', lng);
});

export default i18n;
